// src/components/TeacherSidebar.js
import { useState } from 'react';
import CommonSidebar from './CommonSidebar';

function TeacherSidebar({ isOpen, onToggle }) {
  const menuItems = [
    { path: '/teacher', icon: '📊', label: 'Dashboard', exact: true },
    { path: '/teacher/my-courses', icon: '📚', label: 'My Courses' },
    { path: '/teacher/create-course', icon: '➕', label: 'Create Course', exact: true },
    { path: '/teacher/lessons', icon: '⏰', label: 'Lesson Schedule' },
    // "Add Lesson" menu removed - now added through modules
    { path: '/teacher/add-student', icon: '👨‍🎓', label: 'Add Student', exact: true },
    { path: '/teacher/settings', icon: '⚙️', label: 'Settings' }
  ];

  return (
    <CommonSidebar
      isOpen={isOpen}
      onToggle={onToggle}
      userType="teacher"
      menuItems={menuItems}
      logoText={{ primary: "TEACHER", secondary: "PANEL" }}
    />
  );
}

export default TeacherSidebar;